<template>
  <v-menu
    bottom
    left
    v-if="account.role != 'admin' && $route.name == 'chatting' && !isMobile && !$vuetify.breakpoint.xsOnly"
  >
    <v-btn
      slot="activator"
      icon
      :dark="$store.state._User.connexionType  == 'freshdesk' ? false : true"
    >
      <v-icon>{{changeView.icone}}</v-icon>
    </v-btn>
    <v-list>
      <v-list-tile v-for="(vuePupitre, i) in vuePupitre" :key="i" @click="changeViewPupitre(vuePupitre.value)">
        <v-icon>{{ vuePupitre.icone }}</v-icon>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      vuePupitre: [
        { value: 1, icone: 'filter_1' },
        { value: 2, icone: 'filter_2' },
        { value: 4, icone: 'filter_4' }
      ]
    }
  },

  mounted () {
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', [
      'CHANGE_VIEW_PUPITRE'
    ]),
    changeViewPupitre (data) {
      this.CHANGE_VIEW_PUPITRE(data)
    }
  },

  watch: {
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['pupitreViewStatus']),
    ...mapGetters('_User', ['account']),
    changeView () {
      let selectedView = this.vuePupitre.find(p => this.pupitreViewStatus === p.value)
      this.$cookie.set('wz-pupitreView', selectedView.value, { expires: '1Y' })
      return selectedView
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzPupitreStatus.vue